export default "__VITE_ASSET__BeV9vih7__"